<template>
  <el-tooltip effect="light" :content="tipList[titInd]">
    <img :src="require('@/assets/imgs/shop/uesrIcon' + (titInd + 1) + '.png')" alt="">
  </el-tooltip>
</template>

<script>
export default {
  name: "index",
  props: {
    titInd: 0,
  },
  data() {
    return {
      tipList: [
        '金龙元宝：通过充值获得，可用于商城消费。',
        '银龙元宝：非常珍贵的货币，可用于商城消费。',
        '积分：充值后获得，可提升VIP等级以及用于积分商城中兑换限量道具。',
        '好运符：通过活动奖励或开启盲盒后获得，可兑换限定道具',
        '包装纸：通过商城购买，赠送他人礼物时使用。',
        '幸运钥匙：使用银龙元宝或者金龙元宝购买获得，可用于开启盲盒获得丰厚奖励。'
      ]
    }
  },
}
</script>

<style scoped></style>
